import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import {
  Route,
  Routes,
  useMatch,
  useNavigate,
  useParams,
} from 'react-router-dom';

import { routes, useOptionalUser } from '@frontend/utils';
import { PageNotFoundView } from '@frontend/views';

import { OrdersView } from './orders.view';

export const OrderRoutes = () => {
  const { user } = useOptionalUser();
  const { shopId } = useParams();
  const navigate = useNavigate();
  const isAtRoot = useMatch('/:shopId');
  const posthog = usePostHog();

  // biome-ignore lint/correctness/useExhaustiveDependencies: the original [shopId] is intentional, re-running on user refetches would redirect mid-session
  useEffect(() => {
    if (!user || !shopId) {
      return;
    }

    if (!Number.isFinite(Number(shopId))) {
      posthog.capture('invalid_shop_id', { shopId });
      navigate(routes.notFound, { replace: true });
      return;
    }

    if (!user.shops.includes(shopId)) {
      posthog.capture('no_user_access_for_shop', { shopId });
      navigate(routes.unAuth, { replace: true });
      return;
    }

    if (isAtRoot) {
      navigate(routes.orders(shopId), { replace: true });
      return;
    }
  }, [shopId]);

  return (
    <Routes>
      <Route path="/" element={<OrdersView />} />
      <Route path="/not-found" element={<PageNotFoundView />} />
    </Routes>
  );
};
